import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Environment icon — shield/badge shape.
 *
 * Dual-tone layered style:
 * - Shield outline in currentColor
 * - Cyan accent fill at 10% inside the shield
 * - No node dots
 */
export const EnvironmentIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Shield path (accent fill + outline) */}
    <path
      d="M12 3 L20 6 V12 C20 16.5 16.5 19.5 12 21 C7.5 19.5 4 16.5 4 12 V6 Z"
      fill="#00d4ff"
      fillOpacity={0.1}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

EnvironmentIcon.displayName = "EnvironmentIcon";

export default EnvironmentIcon;
